import React from 'react'
import { useTranslation } from 'react-i18next'
import { Header, Button, Grid } from 'semantic-ui-react'

import "./Section3.css"

const Section3 = () => {
    const { t } = useTranslation()
    return <div className="Section3">
        <Header className="p-1-t p-1-b" size='huge'>
        {t("home:DiscoverNaroonExperiences")}</Header>
        <Grid centered stackable columns={2} >
            <Grid.Column>
                <div className="bg-1">
                    <Header inverted size='huge' className="w-70 font-3 m-3-r m-3-l m-3-t">
                        {t("home:ThingsToDoOnYourTrip")}</Header>
                    <Button inverted className="rounded-10  m-3-r m-3-l" size='big'>
                        {t("home:Experiences")}
                    </Button>
                </div>
            </Grid.Column>
            <Grid.Column >
                <div className="bg-2">
                    <Header inverted size='huge' className="w-70 font-3 m-3-r m-3-l m-3-t">
                    {t("home:ThingsToDoFromHome")}</Header>
                    <Button inverted className="rounded-10  m-3-r m-3-l text-black" size='big'>
                        {t("home:OnlineExperiences")}
                    </Button>
                </div>
            </Grid.Column>
        </Grid>
    </div>
}
export default Section3